import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { RootState } from "../../../store";
import SidebarIcon from "./sidebar-icon";
import SidebarHeader from "./sidebar-header";
import { routes } from "../../../constants";
import ClientPortalPage from "../../common/enums/client-portal-page";

// @ts-expect-error - css
import styles from "./sidebar.module.scss";

/**
 * @toodo import color from rc settngs
 */
export const RC_COLOR = "#294166";
const BASE_PATH = routes.clientPortal.name;

const SideBar = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const location = useSelector((state: RootState) => state.router.location);
  const { dashBoard, appointments, medicalReports, billing, settings } =
    routes.clientPortal.subRoutes;

  const pages = [
    {
      name: ClientPortalPage.DASHBOARD,
      path: `${BASE_PATH}/${dashBoard.name}`
    },
    {
      name: ClientPortalPage.APPOINTMENTS,
      path: `${BASE_PATH}/${appointments.name}`
    },
    {
      name: ClientPortalPage.MEDICAL_RECORDS,
      path: `${BASE_PATH}/${medicalReports.name}`
    },
    { name: ClientPortalPage.LAB, path: `${BASE_PATH}/lab` },
    { name: ClientPortalPage.BILLING, path: `${BASE_PATH}/${billing.name}` },
    { name: ClientPortalPage.SETTINGS, path: `${BASE_PATH}/${settings.name}` }
  ];

  const handleClick = (to: string) => {
    dispatch(push(to));
  };

  return (
    <div className={styles.sidebarContainer} style={{ backgroundColor: `${RC_COLOR}` }}>
      <SidebarHeader />
      {pages.map((page) => {
        const isActive = location?.pathname === page.path;
        return (
          <ListItem key={page.name} disablePadding className={styles.listItem}>
            <ListItemButton
              onClick={() => handleClick(page.path)}
              className={`${styles.listItemButton} ${isActive ? styles.active : ""}`}
            >
              <ListItemIcon className={styles.listItemButtonIcon}>
                <SidebarIcon name={page.name} />
              </ListItemIcon>
              <ListItemText primary={page.name} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </div>
  );
};

export default SideBar;
